
const addProductVariant = document.querySelectorAll('.add-to-cart');
  addProductVariant.forEach((productButton) => {
     productButton.addEventListener('click',  function(e) {
      console.log('CLICKFJfjdjfj')
        console.log(addProductToCart,'addProductToCart')
       e.preventDefault();
       const variantID = this.dataset.id;
       console.log(this.dataset,'DATA')
       const title = this.dataset.title;
       const price = this.dataset.price;
       const image = this.dataset.image;
       const nImage = document.querySelector('.notification .image');
       const nTitle = document.querySelector('.notification .title');
        const nSize= document.querySelector('.notification .sizes');
        const nPrice = document.querySelector('.notification .price');
        console.log(`http://the-original-cones.myshopify.com/cdn/shop/${image}`);
        nImage.innerHTML = `
        <div class="product-card-wrapper bg-white">
        <img src="http://the-original-cones.myshopify.com/cdn/shop/${image}" height="300" width=180" style="object-fit: cover" class="my-2" alt="${title}" />
        </div>`;
        nPrice.innerHTML = `€ ${(price / 100).toFixed(2)}`;
        nTitle.innerHTML = `${title}`;
  
       addProductToCart(variantID, title, price, image);
       notification.classList.add('active');

      setTimeout(() => {
        const notification = document.querySelector('.notification');
        notification.classList.remove('active');
      },4500)

     });
  });

  const notification = document.querySelector('.notification');
  const closeNotification = document.querySelectorAll('.close-notification');
  closeNotification.forEach((button) => {
    button.addEventListener("click", function() {
      console.log(button,'button');
      notification.classList.remove('active');
    });
  });

function addProductToCart(variantID, title, price, image, quantity) {
  const notification = document.querySelector('.notification');
    console.log('testff',notification);

    
    
    

    const priceCart = document.querySelector('.cart-price');
    let item = {
      'items': [{
       'id': variantID,
       'quantity': quantity
       }]
     };
     
     fetch('/cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(item)
     })
     .then(response => {
      response.json().then((res) => {
        
        // const { image, final_price, variant_title, quantity  } = res.items;
        // console.log(res.items)
        // showPopup(title, status, image, final_price, variant_title, quantity);
        // const price = final_price;
        totalPrice(price);
      })
     })
     .catch((error) => {
       console.error('Error:', error);
     });

    async function totalPrice(price) {
        await fetch('/cart.js')
        .then(response => response.json())
        .then(data => { 
        let total = data.total_price / 100;
        const nSubtotal = document.querySelector('.notification .subtotal-price');
        if(priceCart) {
          priceCart.innerHTML = `${(total).toLocaleString("nl-NL", {style: "currency", currency: "EUR", minimumFractionDigits: 2})}`;
        }
        nSubtotal.innerHTML = `${(total).toLocaleString("nl-NL", {style: "currency", currency: "EUR", minimumFractionDigits: 2})}`;
        });
    }

    function showPopup(title, status, image, price, size, count, total) {
        price = price / 100;
        const n = document.querySelector('.notification');
        const nTitle = document.querySelector('.notification .title');
        
        const nCount = document.querySelector('.notification .count');
        nTitle.innerHTML = `<b>${title}</b>`;
        nImage.innerHTML = `<img src="${image}" alt="${title}" />`;
        nPrice.innerHTML = 'hopi';
        nPrice.innerHTML = `${(price).toLocaleString("nl-NL", {style: "currency", currency: "EUR", minimumFractionDigits: 2})}`;
        nSize.innerHTML = `${size}`;
        nCount.innerHTML = `${count}`;
        setTimeout( () => {
            n.classList.add('active');
        } ,600);
    }
    closeNotification.forEach((button) => {
      button.addEventListener("click", function() {
        button.classList.remove('active');
    });
    })


    setTimeout(() => {
        notification.style.display = "unset";
    })


    setTimeout(() => {
      const notification = document.querySelector('.notification');
      notification.classList.remove('active');
    },4500)


    
    fetch('/cart.js')
  .then(response => response.text())
  .then(responseText => {
    const data = JSON.parse(responseText);
    console.log(data.item_count, 'fjhsdfj');

    console.log(data.item_count, typeof data.item_count,"FDSFSDSDFDF")
    const counterEl = document.querySelector('.cart-link__count');
    counterEl.innerHTML = `${data.item_count}`;
    
  })
  .catch(error => {
    console.error('Error fetching cart data:', error);
  });
}


setTimeout(() => {
    
},200);